import logo from 'assets/img/logos/logobn.png';
import './style/header.css';

const Header = () => {
  return (
    <div id="header">
      <div className="row align-items-center">

        <div className="col">
          <img id="logoTranformar" src={logo} alt='logo tranformar' />
        </div>

        <div id="titulo" className="col-6 text-center">

          <h4 id="title"> Opciones de pago de la referencia</h4>
        </div>

        <div id="btn-inicio" className="col">
          <a id="inicio" href="https://esefina.ingresos-guerrero.gob.mx/">
            <i className="fas fa-home"></i>
            Inicio
          </a>
        </div>
      </div>
    </div>
  )
}

export default Header
